import React, { forwardRef } from 'react';
var Div = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: props.style,
    ref: ref
  }, props.children);
});
Div.displayName = 'Div';
export default Div;